/**
 * Converts a string to a URL-friendly slug.
 * @param str - The string to convert
 * @returns A URL-friendly slug
 * @example
 * ```ts
 * toSlug("My Organization Name") // "my-organization-name"
 * toSlug("Hello World!") // "hello-world"
 * ```
 */
export function toSlug(str: string): string {
  return str
    .toLowerCase() // convert to lowercase
    .trim() // remove leading/trailing whitespace
    .normalize('NFD') // normalize unicode characters
    .replace(/\p{Diacritic}/gu, '') // remove diacritics
    .replace(/[^\w\s-]/g, '') // remove non-word chars (except spaces and hyphens)
    .replace(/[\s_]+/g, '-') // replace spaces and underscores with hyphens
    .replace(/-+/g, '-') // remove consecutive hyphens
    .replace(/^-+|-+$/g, ''); // remove leading/trailing hyphens
}
